var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 10.5417V13.6251C15.4167 16.2251 12.9917 18.3334 10 18.3334C7.00833 18.3334 4.58333 16.2251 4.58333 13.6251V10.5417C4.58333 13.1417 7.00833 15.0001 10 15.0001C12.9917 15.0001 15.4167 13.1417 15.4167 10.5417Z",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 6.37508C15.4167 7.13342 15.2083 7.83341 14.8417 8.43341C13.95 9.90008 12.1167 10.8334 10 10.8334C7.88333 10.8334 6.05 9.90008 5.15833 8.43341C4.79166 7.83341 4.58333 7.13342 4.58333 6.37508C4.58333 5.07508 5.19166 3.90008 6.16666 3.05008C7.14999 2.19175 8.5 1.66675 10 1.66675C11.5 1.66675 12.85 2.19175 13.8333 3.04175C14.8083 3.90008 15.4167 5.07508 15.4167 6.37508Z",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 6.37508V10.5417C15.4167 13.1417 12.9917 15.0001 10 15.0001C7.00833 15.0001 4.58333 13.1417 4.58333 10.5417V6.37508C4.58333 3.77508 7.00833 1.66675 10 1.66675C11.5 1.66675 12.85 2.19175 13.8333 3.04175C14.8083 3.90008 15.4167 5.07508 15.4167 6.37508Z",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.f226009c145f980a2f13cb6a8af0d268.svg";
export { ForwardRef as ReactComponent };